export enum SuspensionType {
  Payment,
  Courtesy,
}

export const suspensionTypeValues: { [id: number]: string } = {
  0: 'Falta de pago',
  1: 'Cortesía',
};

export namespace SuspensionType {
  export function values() {
    let values = Object.keys(SuspensionType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: suspensionTypeValues[index], value: index };
      });
    return values;
    // return values.filter((x) => x.value != 0);
  }
}
